module.exports = __webpack_public_path__ + "img/photo-1.463bd428.png";